module.exports = __webpack_public_path__ + "img/reka.5468cdf4.jpg";